
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { addCurrencyUnit } from "@common/src/utils/tools";
const employee = namespace("employee");
const category = namespace("parts-category");
const serviceItem = namespace("service-item");
@Component({})
export default class FilterProjectParts extends Vue {
  @employee.State filterProjectPartsDialog;
  @employee.Mutation setFilterProjectPartsDialog;
  @employee.Action getServiceItemPage;
  @employee.Action getPartsPage;
  @category.Action getCategoryList;
  @serviceItem.Action queryTwoLevelClassList;
  isIndeterminate = false;
  formInline = {
    user: "",
    region: ""
  };
  tableData = [];
  checkedCities = [];
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  splitThousands = splitThousands;
  chechedAll = false;
  multipleSelectionArr = [];
  CategoryCodeList = [];
  getPushMoney = "project";
  loading = false;
  searchForm = {
    pageNum: 1,
    pageSize: 1000,
    serviceCategoryCode: undefined,
    serviceNumber: undefined,
    serviceName: undefined
  };
  created() {
    this.getPushMoney = this.$route.params.type;
    this.init();
  }

  async init() {
    if (this.getPushMoney === "parts") {
      const partsList = await this.getCategoryList({ pageNum: 1, pageSize: 1000 });
      this.CategoryCodeList = this.addLeafFlag(this.$safeValue(partsList, "data", []));
      this.getParts();
    } else {
      const serverList = await this.queryTwoLevelClassList({ pageNum: 1, pageSize: 1000 });
      this.CategoryCodeList = serverList.data.list;
      this.getServer();
    }
  }
  wouldCheck(row) {
    if (row.hasCommission !== "true") {
      return true;
    } else {
      return false;
    }
  }
  async getServer() {
    this.loading = true;
    const res = await this.getServiceItemPage(this.searchForm);
    this.tableData = res.data.list;
    this.loading = false;
  }
  partsObj = {
    label: "categoryName",
    value: "categoryCode"
  };
  async getParts() {
    let partsForm = {
      pageNum: 1,
      pageSize: 1000,
      partsCategoryCode:
        this.searchForm.serviceCategoryCode && this.searchForm.serviceCategoryCode instanceof Array
          ? this.searchForm.serviceCategoryCode[this.searchForm.serviceCategoryCode.length - 1]
          : this.searchForm.serviceCategoryCode,
      partsNumber: this.searchForm.serviceNumber,
      partsName: this.searchForm.serviceName
    };
    this.loading = true;
    const res = await this.getPartsPage(partsForm);
    this.tableData = res.data.list;
    this.loading = false;
  }
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  handleClose() {
    const refsForm = this.$refs.searchForm as any;
    refsForm.resetFields();
    this.init();
    this.setFilterProjectPartsDialog(false);
  }
  iAmSure() {
    const refsForm = this.$refs.searchForm as any;
    refsForm.resetFields();
    this.init();
    this.$emit("getArr", this.multipleSelectionArr);
    this.setFilterProjectPartsDialog(false);
  }
  onSubmit() {
    if (this.getPushMoney === "parts") {
      this.getParts();
    } else {
      this.getServer();
    }
  }
  onReset() {
    this.$nextTick(() => {
      let ref = this.$refs.searchForm as any;
      ref.resetFields();
      this.init();
    });
  }
  checkChange(val) {
    let tableRef = this.$refs.multipleTable as any;
    tableRef.toggleAllSelection();
    this.checkedCities = val ? this.tableData : [];
    this.isIndeterminate = false;
  }
  handleSelectionChange(selection) {
    this.multipleSelectionArr = selection;
    this.chechedAll = selection.length ? true : false;
    let checkedCount = selection.length;
    this.chechedAll = checkedCount === this.tableData.length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length;
  }
  selectAll(selection) {
    this.chechedAll = selection.length ? true : false;
  }
}
